<template>
  <div v-if="terms">
    <top-bar :user="user" />
    <MenuItems :user="this.user" :menuSelected="{ dashboard: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="{ dashboard: true }" />
    </div>
    <div class="container-right">
      <div :class="{
        content: true,
        'dashboard-beneficiary': true,
      }">
        <h1>{{ $t("welcomeTitle", { name: user.person.first_name }) }}</h1>
        <p>{{ $t("welcomeMessage") }}</p>
        <br />

        <div>
          <!-- <b-carousel id="carousel-1" :interval="4000" indicators> -->
          <div class="d-inline-block" v-for="(entry, index) in homeImages" :key="index">
            <div class="home-wrapper" :style="{
              background:
                'url(' +
                require('@/assets/images/home/' + entry.fileName) +
                ') no-repeat center left ',
            }">
              <h5 class="white">{{ entry.title }}</h5>
              <p class="white">{{ $t(entry.description) }}</p>
              <a class="button-all button-white" :href="entry.pathName">{{
                $t("textButtonDiscover")
              }}</a>
              <!-- <b-form-checkbox
                              class="quantity-checkbox"
                              v-model="selectedStickers"
                              :value="mediumSticker"
                              ></b-form-checkbox> -->
            </div>
          </div>
          <!-- </b-carousel-slide> -->
          <!-- </b-carousel> -->
        </div>
        <br />

        <!-- adaugat square quick link to dashboard -->
        <h1>{{ $t("dashboardTitle") }}</h1>
        <p>{{ $t("dashboardMessage") }}</p>
      </div>
    </div>
  </div>
  <div v-else id="modal_popup_terms" class="modal-popup">
    <div class="modal-popup-content">
      <p>
        <iframe v-if="this.config" :src="this.config.terms"></iframe>
      </p>
      <a class="button-all button-orange" @click="acceptTerms()">{{
        $t("acceptTerms")
      }}</a>
      <a class="button-all button-white" @click="logout()">{{ $t("declineTerms") }}</a>
      <!-- <LinkFrame v-if="this.config" :urlAddress="this.config.terms" /> -->
    </div>
</div>
</template>

<script>
import Cookies from "js-cookie";
import TopBar from "../components/company/TopBar.vue";
import MenuItems from "../components/company/MenuItems.vue";
import httpServiceUser from "@/http/http-customer.js";
import homeImages from "@/assets/json/home.js";

export default {
  name: "Dashboard",
  components: { TopBar, MenuItems },
  data() {
    return {
      user: null,
      homeImages: homeImages,
      config: JSON.parse(sessionStorage.getItem("club_jsonFile")),
      terms: false,
      termsError: null,

    };
  },
  methods: {
    acceptTerms() {
      if (this.user.status !== "3") {
        this.terms = true;
        this.showModalPopup("modal_popup_terms", false);
      } else {
        this.user.status = "0";
        httpServiceUser.customerService
          .updateUserInfo(this.user, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
      .then((response) => {
        if (response.status == 200) {
          this.terms = true;
          this.user = this.getUser();
        } else if (response.status == 400) {
          this.user.status = "3";
          this.termsError = response.data;
        } else {
          this.user.status = "3";
          this.termsError = { description: response.code };
        }
        this.showModalPopup("modal_popup_terms", false);
        this.dataLoaded = true;
      })
      .catch((error) => {
        this.user.status = "3";
        this.termsError = error.response.data;
        this.showModalPopup("modal_popup_terms", false);
      });
  }
},
logout() {
  Cookies.remove("userLink");
  Cookies.remove("token");
  this.$router.push({
    name: "login",
    params: { loginUserSelected: false },
  });
},
  },
mounted() {
  if (this.user && this.user.status === "3") {
    this.showModalPopup("modal_popup_terms", true);
  } else {
    this.terms = true;
  }
},
created() {
  this.user = this.getUser();
  // this.config = JSON.parse(localStorage.getItem("club_jsonFile"));    
},
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped>
.home-wrapper {
  padding: 10px;
  width: auto;
  max-width: 370px;
  height: 317px;
  display: flex;
  flex-wrap: wrap;
  margin-right: 15px;
  align-content: flex-end;
  /* color: #eee; */
}


#modal_popup_terms {
  position: fixed;
}


#modal_popup_terms .modal-popup-content {
  width: 80%;
  height: 90%;
  max-width: 80% !important;

}

#modal_popup_terms .modal-popup-content>p {
  width: 100%;
  height: 90%;
}

#modal_popup_terms .modal-popup-content>p>iframe {
  width: 100%;
  height: 100%;
  border: 0 none;
}
</style>

